import _ from "lodash";
import Event from "@/services/Event";
import EnrollmentCard from "@/components/Enrollments/Card";
import EnrollmentTeamCard from "@/components/Admin/Enrollment/TeamCard";
import TeamCard from "@/components/Teams/Card";
import UsersCard from "@/components/Users/Card";

import ParseHTTPError from "@/helpers/ParseHTTPError";
import Unwind from "@/helpers/Unwind";
import { Parser } from "json2csv";

import { mapState, mapGetters } from "vuex";

import getJudgeTypes from "@/helpers/events/getJudgeTypes";

export default {
  name: "EventsDraw",

  components: {
    EnrollmentCard,
    EnrollmentTeamCard,
    TeamCard,
    UsersCard,
  },

  data() {
    return {
      totalRooms: 5,

      eventId: null,

      event: {},
      enrollments: [],

      rooms: [],

      finalDraws: {},

      isDrawed: false,
      isFinalDraw: false,

      loading: false,
    };
  },

  created() {
    this.eventId = this.$route.params.id;

    this.fetchEvent();
    this.fetchEnrollments();

    this.getDraw();
    this.createRooms();
  },

  watch: {
    roomsNumber() {
      this.isDrawed = false;
      this.rooms = [];
      this.createRooms();
    },
  },

  methods: {
    goBack() {
      return this.$router.back();
    },

    clearDraw() {
      if (this.isFinalDraw) return;
      this.isDrawed = false;
      this.rooms = [];
      this.createRooms();
    },

    distribute(arr, number) {
      const result = _.times(number, () => []);
      const tmp = _.clone(arr);

      let pos = 0;

      while (tmp.length) {
        const item = tmp.shift();
        const index = pos % number;
        pos += 1;
        result[index].push(item);
      }

      return result;
    },

    makeDraw() {
      this.enrollments = _.shuffle(this.enrollments);

      this.distribute(this.classifiedTeams, this.totalRooms).forEach(
        (chunk, index) => {
          const room = this.getRoom(String.fromCharCode(65 + index));
          room.teams = chunk;
        },
      );

      this.isDrawed = true;
    },

    createRooms() {
      this.rooms = this.roomsNumber.map((number) => ({
        number: number,
        teams: [],
        judges: [],
      }));
    },

    getRoom(number) {
      return _.find(this.draws, { number });
    },

    fetchEvent() {
      Event.get(this.eventId).then(
        (res) => {
          this.event = res.data;
        },
        () => {},
      );
    },

    fetchEnrollments() {
      this.loading = true;

      Event.enrollments(this.eventId, { includes: ["entity"] }).then(
        (res) => {
          this.loading = false;

          this.enrollments = res.data;
        },
        () => {
          this.loading = false;
        },
      );
    },

    confirmSubmitResult() {
      this.$dialog({
        width: "350px",
        customClass: "tournament-white pa-4",
        title:
          "Você deseja salvar o resultado deste sorteio? Ele não poderá ser modificado posteriormante.",
        buttons: [
          { name: "Cancelar", class: "tournament-grey--text ma-0" },
          {
            name: "Salvar",
            action: "submit",
            class: "tournament-green--text ma-0",
          },
        ],
      })
        .then(() => {
          this.submitDraw();
        })
        .catch(() => {});
    },

    submitDraw() {
      const parsedRooms = this.rooms.map((room) => ({
        ...room,
        teams: _.map(room.teams, "_id"),
      }));

      Event.createDraw(this.eventId, parsedRooms)
        .then(() => {
          this.getDraw();
        })
        .catch(() => {
          console.log("there was an error");
        });
    },

    getDraw() {
      Event.getDraw(this.eventId)
        .then((res) => {
          if (res.data) {
            this.isFinalDraw = true;
            this.finalDraws = res.data;
          }
        })
        .catch(() => {});
    },

    publishResults() {
      const answers = [];
      this.roomsNumber.map((number) => {
        // number++;
        this.getRoom(number).teams.forEach((team) => {
          answers.push({
            name: team.entity.name,
            target: team.entity._id,
            targetKind: "member",
            choices: [
              {
                field: "000000000000000000000001",
                name: "Sala de Avaliação",
                text: ["Sala " + number],
              },
              {
                field: "000000000000000000000002",
                name: "Observação",
                longtext: [""],
              },
            ],
          });
        });

        this.getRoom(number).judges.forEach((team) => {
          answers.push({
            name: team.entity.name,
            target: team.entity._id,
            targetKind: "user",
            choices: [
              {
                field: "000000000000000000000001",
                name: "Sala de Avaliação",
                text: ["Sala " + number],
              },
              {
                field: "000000000000000000000002",
                name: "Observação",
                longtext: [""],
              },
            ],
          });
        });
      });

      console.log("Evento: " + this.event.name);
      console.log("Targets: ", this.event);
      console.log(answers);

      window.Layers.ui("createPost", {
        title: `Resultado sorteio de salas - ${this.event.name}`,
        type: "report",
        targets: [
          {
            ...this.event,
            type: "group",
          },
        ],
        roles: ["robotics:coach", "team:member"],
        report: {
          answers: answers,
          report: {
            name: "sorteio",
            fields: [
              {
                _id: "000000000000000000000001",
                name: "Sala de Avaliação",
                type: "text",
              },
              {
                _id: "000000000000000000000002",
                name: "Observação",
                type: "longtext",
              },
            ],
          },
        },
      });
    },

    addJudgeInRoom(number, e) {
      const room = _.find(this.finalDraws.rooms, { number });
      room.judges = e;

      Event.updateJudges(this.eventId, number, room.judges)
        .then(() => {
          this.$notify.success({
            title: "OK",
            message: "Juiz atualizado com sucesso",
          });

          this.getDraw();
        })
        .catch((err) => {
          const status = ParseHTTPError(err);

          this.$notify.error({
            title: "Erro",
            message: status.error,
          });
        });
    },

    openJudge(enrollment) {
      this.$router.push({
        name: "submit",
        params: {
          cache: enrollment,
          modelId: enrollment._id,
          impersonate: true,
          kind: "judge",
        },
      });
    },

    removeJudge(number, enrollment) {
      const room = _.find(this.finalDraws.rooms, { number });
      _.pull(room.judges, enrollment._id);

      Event.updateJudges(this.eventId, number, room.judges)
        .then(() => {
          this.$notify.success({
            title: "OK",
            message: "Juiz removido com sucesso",
          });

          this.getDraw();
        })
        .catch((err) => {
          const status = ParseHTTPError(err);

          this.$notify.error({
            title: "Erro",
            message: status.error,
          });
        });
    },

    openTeam(enrollment) {
      this.$router.push({
        name: "submit",
        params: {
          cache: enrollment,
          modelId: enrollment._id,
          impersonate: true,
          kind: "team",
        },
      });
    },

    findJudgeType(type) {
      const obj = _.find(getJudgeTypes(this.community), { _id: type }) || {};
      return _.get(obj, "label");
    },

    mapJudgeTypes(types = []) {
      return types.map(this.findJudgeType).join(", ");
    },

    generateDownload(name, data) {
      const fileURL = window.URL.createObjectURL(new Blob([data]));
      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      const fileName = `${name}.csv`;
      fileLink.setAttribute("download", fileName);
      document.body.appendChild(fileLink);
      fileLink.click();
    },

    exportJudges() {
      const json = Unwind(this.inflatedFinalDraws, "judges").map((judge) =>
        _.extend(judge, {
          judgeTypes: this.mapJudgeTypes(_.get(judge, "judges.judge.area", [])),
        }),
      );

      console.log(json);

      const judgeSchema = [
        { label: "Sala", value: "number" },
        { label: "Nome do Juiz", value: "judges.entity.name" },
        { label: "Categoria do Juiz", value: "judgeTypes" },
      ];

      const parser = new Parser({ fields: judgeSchema });
      this.generateDownload(
        `SalasJuizes-${this.event.name}`,
        parser.parse(json),
      );
    },

    exportTeams() {
      const json = Unwind(this.inflatedFinalDraws, "teams");

      const teamsSchema = [
        { label: "Sala", value: "number" },
        { label: "Equipe", value: "teams.entity.name" },
        { label: "Número da equipe", value: "teams.entity.alias" },
        { label: "Nome do técnico", value: "teams.team.mainCoach.name" },
      ];

      const parser = new Parser({ fields: teamsSchema });
      this.generateDownload(
        `SalasTimes-${this.event.name}`,
        parser.parse(json),
      );
    },
  },

  computed: {
    ...mapState(["community"]),
    ...mapGetters(["isSuboperator", "isChiefJudge"]),

    roomsNumber() {
      const roomNumber = _.get(
        this,
        "inflatedFinalDraws.length",
        this.totalRooms,
      );
      return _.range(roomNumber).map((number) =>
        String.fromCharCode(65 + number),
      );
    },

    draws() {
      return this.inflatedFinalDraws || this.rooms;
    },

    inflatedFinalDraws() {
      if (!this.finalDraws.eventId) return null;

      return this.finalDraws.rooms.map((room) => {
        return {
          ...room,
          teams: room.teams.map((e) => _.find(this.enrollments, { _id: e })),
          judges: room.judges.map((e) => _.find(this.enrollments, { _id: e })),
        };
      });
    },

    teams() {
      return this.enrollments.filter(
        (enrollment) => enrollment.kind === "team",
      );
    },

    judges() {
      return this.enrollments.filter(
        (enrollment) => enrollment.kind !== "team",
      );
    },

    classifiedTeams() {
      return this.teams.filter(
        (team) => _.get(team, "situation.status._id") == "confirmed",
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/Admin/EventsDraw/EventsDraw.js